import React from 'react'
import { Link } from 'react-router-dom'

function Nav() {
    return (
        <>
            <div className='nav-container'>
                <div className='nav-bar'>
                    <Link to='/'>Home</Link>
                    <Link to='/3D'>3D</Link>
                    <Link to='/Dev'>Frontend Web Developer</Link>
                </div>

            </div>
        </>
    )
}

export default Nav